export const PSY_CHART = {
  navy: '#111a31',
  ink: '#172033',
  text: '#475569',
  muted: '#7c899b',
  line: '#e4e9f1',
  indigo: '#5547e8',
  indigoDark: '#4338ca',
  blue: '#2563eb',
  cyan: '#0891b2',
  green: '#0f9f6e',
  amber: '#d97706',
  red: '#dc2626',
  violet: '#7c3aed',
  slate: '#94a3b8',
};

export const PSY_CHART_SERIES = [
  PSY_CHART.indigo,
  PSY_CHART.blue,
  PSY_CHART.green,
  PSY_CHART.amber,
  PSY_CHART.violet,
  PSY_CHART.cyan,
];

export const PSY_AXIS_TICK = {
  fill: PSY_CHART.muted,
  fontSize: 11,
  fontWeight: 600,
};

export const PSY_GRID_PROPS = {
  stroke: PSY_CHART.line,
  strokeDasharray: '4 6',
  vertical: false,
};
